// extracted by mini-css-extract-plugin
export default {"wrapper":"get_in_touch-icons_wrapper__7294s","icon":"get_in_touch-icons_icon__jrW0H","title":"get_in_touch-icons_title__qgqjj","description":"get_in_touch-icons_description__UoEG5"};